import { render, staticRenderFns } from "./TestSdk.vue?vue&type=template&id=40b1dcc2"
import script from "./TestSdk.vue?vue&type=script&lang=js"
export * from "./TestSdk.vue?vue&type=script&lang=js"
import style0 from "./TestSdk.vue?vue&type=style&index=0&id=40b1dcc2&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports